import { render, staticRenderFns } from "./PostageRateCalculator.vue?vue&type=template&id=058c76bb&scoped=true"
import script from "./PostageRateCalculator.vue?vue&type=script&lang=js"
export * from "./PostageRateCalculator.vue?vue&type=script&lang=js"
import style0 from "./PostageRateCalculator.vue?vue&type=style&index=0&id=058c76bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058c76bb",
  null
  
)

export default component.exports